import logo from './logo.svg';
import './App.css';
import CaloriePage from './Components/CaloriePage';

function App() {
  return (
    <div className="App">
     <CaloriePage/>
    </div>
  );
}

export default App;
